import { HttpHeaders } from '@angular/common/http'
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import * as CryptoJS from 'crypto-js';
import PackageInfo from '../../../package.json';
import { UserDTO } from '../models/user/user.dto';

@Injectable()
export class Globals {
    static envLabel = environment.label;
    static apiEndpoint = environment.apiEndpoint
    static superAdminApiEndpoint = environment.superAdminApiEndpoint
    static defaultHttpTimeout = environment.defaultHttpTimeout
    static longHttpTimeout = environment.longHttpTimeout
    static superLongHttpTimeout = environment.superLongHttpTimeout
    static production = environment.production
    static source = environment.source;
    static appVersion = PackageInfo.version
    private static ENCRYPT_SECRET_KEY = 'bBqVsmwp5l4V2kF2nvjMLC7jYpa8r2iYllQAyvjz5nY=';
    private static AUTH_TOKEN_KEY = "jshkuot4im456jdsnndxm";
    private static USER_KEY = "3488gdklskd5043jflds";

    constructor() { }

    public static encryptString(unencryptedString: string): string {
        return CryptoJS.AES.encrypt(unencryptedString, this.ENCRYPT_SECRET_KEY).toString();
    }

    public static decryptString(encryptedString: string): string | null {
        if (encryptedString == null || encryptedString == undefined || encryptedString == "") {
            return null
        }
        return CryptoJS.AES.decrypt(encryptedString, this.ENCRYPT_SECRET_KEY).toString((CryptoJS.enc.Utf8));
    }

    static getHeaders(timeout: any) {
        return {
            headers:
                new HttpHeaders()
                    .set('Accept', "application/json")
                    .set('Content-Type', "application/json")
                    .set('locale', "en")
                    .set('request-platform', "android")
                    .set('Authorization', 'Bearer ' + this.getToken())
        }
    }

    static saveToken(token: string) {
        localStorage.setItem(this.AUTH_TOKEN_KEY, this.encryptString(token));
    }

    static getToken() {
        const token  = localStorage.getItem(this.AUTH_TOKEN_KEY);
        if (token) {
            return this.decryptString(localStorage.getItem(this.AUTH_TOKEN_KEY) as string)    
        }
        return null;
    }

    static saveUser(user: UserDTO) {
        localStorage.setItem(this.USER_KEY, this.encryptString(JSON.stringify(user)));
    }

    static getUser(): UserDTO | null {
        const mUser = this.decryptString(localStorage.getItem(this.USER_KEY) as string);
        if (mUser != null) {
            return JSON.parse(mUser)
        }
        return null;
    }
    
    static isLoggedIn() {
        let token = this.getToken();
        if (token == null) {
            return false;
        }
        if (token == '') {
            return false;
        }
        return true;
    }

    static clearLocalStorage() {
        localStorage.removeItem(this.AUTH_TOKEN_KEY)
        localStorage.removeItem(this.USER_KEY)
      }
}

